import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

const LOPLink = ({ mapUrl }) => {
  const [imgSize, setImgSize] = useState({ width: 1200, height: 800 });

  useEffect(() => {
    if (!mapUrl) return;
    const img = new Image();
    img.src = mapUrl;
    img.onload = () => {
      setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
    };
  }, [mapUrl]);

  useEffect(() => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: "#gallery--with-download-button",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.on("uiRegister", function () {
      lightbox.pswp.ui.registerElement({
        name: "download-button",
        order: 8,
        isButton: true,
        tagName: "a",
        html: {
          isCustomSVG: true,
          inner:
            '<path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" id="pswp__icn-download"/>',
          outlineID: "pswp__icn-download",
        },
        onInit: (el, pswp) => {
          el.setAttribute("target", "_blank");
          el.setAttribute("rel", "noopener");

          pswp.on("change", () => {
            const url = pswp.currSlide.data.src;
            el.setAttribute("href", url);
            el.setAttribute("download", `image-${pswp.currIndex + 1}.png`);
          });
        },
      });
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  return (
    <NavLink id="gallery--with-download-button">
      <a
        href={mapUrl}
        data-pswp-width={imgSize.width}
        data-pswp-height={imgSize.height}
        target="_blank"
        rel="noreferrer"
      >
        View LOP
      </a>
    </NavLink>
  );
};

export default LOPLink;
